import { Box, Button, InputAdornment, TextField } from "@mui/material";
import { useFormik } from "formik";
import { Fragment, useState } from "react";

import * as yup from "yup";
import { resetPasswordService } from "../../services/auth";
import BackButton from "../../components/BackButton";
import { useNavigate } from "react-router-dom";
import { HiLockClosed } from "react-icons/hi";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = yup.object({
  mobile: yup
    .string("Enter your mobile")
    .min(5, "too short")
    .max(255, "too long")
    .test("test-name", "Enter Valid Mobile number", function (value) {
      const emailRegex =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let isValidEmail = emailRegex.test(value);
      let isValidPhone = phoneRegExp.test(value);
      if (!isValidEmail && !isValidPhone) {
        return false;
      }
      return true;
    })
    .required("Enter Valid Mobile number"),
  code: yup
    .string("Enter your mobile")
    .min(5, "too short")
    .max(6, "too long")
    .required("Please enter verification code you have received"),
  password: yup
    .string("Password")
    .min(6, "too short")
    .max(50, "too long")
    .required("Password is required"),
});

export default function ResetPasswordLastStep({ mobile, code, setStep }) {
  const nav = useNavigate();

  const [loading, setLoading] = useState(false);

  const toLogin = () => nav("/login");
  const goBack = () => setStep("verify_code");

  const formik = useFormik({
    initialValues: {
      mobile: mobile,
      code: code,
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { mobile, code, password } = values;
      setLoading(true);

      const { error } = await resetPasswordService({
        body: { mobile, code, password },
      });
      setLoading(false);
      if (error) {
        if (error) {
          formik.setFieldError("password", error);
          return console.error(error);
        }
      }
      toLogin();
    },
  });

  return (
    <Fragment>
      <BackButton
        primaryText="Reset"
        secondaryText="Password"
        goBack={goBack}
      />
      <Box width={1}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          sx={{ width: "99%", height: 1 }}
        >
          <Box sx={{ width: "100%", my: 2 }}>
            <TextField
              fullWidth
              id="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              type="password"
              variant="standard"
              placeholder="New Password"
              InputProps={{
                sx: { minHeight: "56px" },
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment
                    sx={{ color: "text.secondary" }}
                    position="start"
                  >
                    <HiLockClosed size={25} />
                  </InputAdornment>
                ),
              }}
              sx={{
                backgroundColor: "background.paper",
                borderRadius: "8px",
                minHeight: "56px",
                display: "flex",
                alignItems: "center",
                px: 2,
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box width={1}>
        <Button
          fullWidth
          type="submit"
          sx={{ py: 1.5, mt: 7 }}
          variant="contained"
          disabled={loading}
          onClick={formik.handleSubmit}
          color="secondary"
        >
          Save
        </Button>
      </Box>
    </Fragment>
  );
}
